import { Moment } from 'moment';
import PartsOrderStatus from '@/dossier/constants/PartsOrderStatus';
import PickingStatus from '@/dossier/constants/PickingStatus';
import VehicleStatus from '@/dossier/constants/VehicleStatus';
import WorkStatus from '@/dossier/constants/WorkStatus';
import { DossierId } from '@/dossier/models/AbstractDossier';
import Tag from '@/shared/models/Tag';
import { RegistrationNumber } from '@/vehicle/models/Vehicle';
import WorkPreparationStatus from '../constants/WorkPreparationStatus';
import WorkPreparationItem from './WorkPreparationItem';

export default class WorkPreparationSearchResult {
  id!: DossierId;
  workPreparationStatus: WorkPreparationStatus | null = null;
  tags: Array<Tag> = [];
  vehicleStatus: VehicleStatus | null = null;
  workStatus: WorkStatus | null = null;
  pickingStatus: PickingStatus | null = null;
  partsOrderStatus: PartsOrderStatus | null = null;
  plannedVisit!: Moment;
  externalReference: string | null = null;
  registrationNumber: RegistrationNumber | null = null;
  workPreparations: Array<WorkPreparationItem> = [];
  hasPreCheckin = false;
  waitsOnPremise = false;
}